<template>
    <main class="notifications-page max-width-container">
        <h1>Notifications</h1>

        <div v-if="notifications.length > 0" class="notifications-list">
            <div
                v-for="notification in notifications"
                :key="notification.id"
                class="notification-row"
                :class="{ 'is-handled': notification.status !== 'pending' }"
            >
                <div class="notification-content">
                    <span class="notification-icon material-symbols-outlined">
                        {{ notification.icon || "notifications" }}
                    </span>
                    <span class="notification-text">
                        <span class="notification-message">
                            {{ notification.message }}
                        </span>
                        <span
                            v-if="notification.list_url"
                            class="notification-links"
                        >
                            <router-link
                                v-if="notification.item_url"
                                :to="notification.item_url"
                            >
                                {{ itemLabel(notification.type) }}
                            </router-link>
                            <router-link :to="notification.list_url">
                                {{ listLabel(notification.type) }}
                            </router-link>
                        </span>
                    </span>
                </div>

                <div class="notification-actions">
                    <template v-if="notification.status === 'pending'">
                        <button
                            class="icon-button action-button approve-btn"
                            title="Approve"
                            @click="approve(notification.id)"
                        >
                            <span class="material-symbols-outlined">check</span>
                        </button>
                        <button
                            class="icon-button action-button reject-btn"
                            title="Reject"
                            @click="reject(notification.id)"
                        >
                            <span class="material-symbols-outlined">close</span>
                        </button>
                    </template>
                    <div
                        v-else
                        class="notification-badge"
                        :class="notification.status"
                    >
                        {{ notification.status.toUpperCase() }}
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="empty-state">
            <p>You have no notifications.</p>
        </div>
    </main>
</template>

<script>
import { create, fetch } from "js/lib/server";
import { useUserStore } from "js/stores/userStore";
import { useTripStore } from "js/stores/tripStore";
import { useBucketListStore } from "js/stores/bucketListStore";
import { useSavedIdeaStore } from "js/stores/savedIdeaStore";

const TYPE_TO_ICON = {
    friend_request: "person_add",
    trip: "travel_explore",
    bucket_list: "bucket_check",
    trip_idea: "smart_toy",
    schedule: "globe_2_question",
};

const TYPE_TO_LABELS = {
    friend_request: { list: "Friends" },
    trip: { item: "Open trip", list: "All trips" },
    bucket_list: { item: "Open bucket list", list: "All bucket lists" },
    trip_idea: { item: "Open idea", list: "Saved ideas" },
    schedule: { list: "Travel schedule" },
};

export default {
    name: "Notifications",
    data() {
        return {
            userStore: null,
            tripStore: null,
            bucketListStore: null,
            savedIdeaStore: null,
            index: {},
            notifications: [],
        };
    },
    mounted() {
        this.userStore = useUserStore();
        this.tripStore = useTripStore();
        this.bucketListStore = useBucketListStore();
        this.savedIdeaStore = useSavedIdeaStore();
        fetch("/api/invitations/?mark-read").then((response) => {
            this.userStore.refreshNotifications(0);
            this.notifications = response.data.data.map((msg, ind) => {
                this.index[msg.id] = ind;
                msg.icon = TYPE_TO_ICON[msg.type];
                return msg;
            });
        });
    },
    methods: {
        handle(id, action) {
            return create(`/api/invitations/${id}/${action}`).then(
                (response) => {
                    const msg = response.data.data;
                    msg.icon = TYPE_TO_ICON[msg.type];
                    this.notifications[this.index[msg.id]] = msg;
                    switch (msg.type) {
                        case "trip":
                            this.tripStore.setDirty();
                            break;
                        case "bucket_list":
                            this.bucketListStore.setDirty();
                            break;
                        case "trip_idea":
                            this.savedIdeaStore.setDirty();
                            break;
                    }
                }
            );
        },
        approve(id) {
            this.handle(id, "accept");
        },
        reject(id) {
            this.handle(id, "decline");
        },
        itemLabel(type) {
            return TYPE_TO_LABELS[type]?.item;
        },
        listLabel(type) {
            return TYPE_TO_LABELS[type]?.list;
        },
    },
};
</script>
